import { validated3dw9xce8adqbh as validated } from './entrypoints.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  lens2gvfhjoqnpofs as lens,
  lens2wuprihu5z787 as lens_0,
  MutableValidatedValuegls7jkstsdwb as MutableValidatedValue,
  lensi9s8q1zaykbw as lens_1,
  lens2dr2mfn274h1a as lens_2,
  MutableValidated2ognu5vxf17ur as MutableValidated,
} from './Validated.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  equals2au1ep9vhcato as equals,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  valueSet3cf2hvvu95f3 as valueSet,
  set3ct43wkzm94lj as set,
  ReactiveValue37mnzha3zo6xb as ReactiveValue,
  Reactive1jy75v4li6ldv as Reactive,
} from '../../core/coreInterfaces.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  _ReactiveState___init__impl__fvdp9b3rxdz1mjh763m as _ReactiveState___init__impl__fvdp9b,
  _ReactiveState___get_raw__impl__92ipya3q1gard26whe6 as _ReactiveState___get_raw__impl__92ipya,
  InternalReactiveWrapper6qytbrc1rcqv as InternalReactiveWrapper,
  InternalReactiveThrownException1wn4fe03qbefg as InternalReactiveThrownException,
  InternalReactiveNotActive_instanceavp2nits8goa as InternalReactiveNotActive_instance,
  InternalReactiveNotReady_instancer79hznuwejmn as InternalReactiveNotReady_instance,
  ReactiveStatel8ixobo86msn as ReactiveState,
} from '../../core/ReactiveState.mjs';
import {
  BaseReactiveValue1ggyqczzm31cy as BaseReactiveValue,
  BaseReactive302n39o7i5yop as BaseReactive,
} from '../../core/abstracts.mjs';
import { IssueNode2x8c6ia7dmfdz as IssueNode } from './IssueNode.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function audit(_this__u8e3s4, validate) {
  return ValidationValueLens().new_com_lightningkite_reactive_lensing_validation_ValidationValueLens_5mqoav_k$(validated(_this__u8e3s4), validate);
}
function audit_0(_this__u8e3s4, validate) {
  return MutableValidationLens().new_com_lightningkite_reactive_lensing_validation_MutableValidationLens_9i3zhn_k$(_this__u8e3s4, validate);
}
var ValidationValueLensClass;
function ValidationValueLens() {
  if (ValidationValueLensClass === VOID) {
    class $ extends ValidatedValueLens() {
      constructor(source, validate) {
        return new.target.new_com_lightningkite_reactive_lensing_validation_ValidationValueLens_5mqoav_k$(source, validate);
      }
      static new_com_lightningkite_reactive_lensing_validation_ValidationValueLens_5mqoav_k$(source, validate) {
        return this.new_com_lightningkite_reactive_lensing_validation_ValidatedValueLens_hzdggt_k$(source, validate);
      }
      set_value_v1vabv_k$(value) {
        var issue = this.validate_1(value);
        this.baseNode_1.report_ins8zt_k$(issue);
        super.set_value_v1vabv_k$(value);
        if (issue == null || issue.setValue_1) {
          // Inline function 'com.lightningkite.reactive.lensing.validation.ValidatedValueLens.withoutListening' call
          try {
            this.listen_1 = false;
            this.source_1.set_value_v1vabv_k$(value);
          }finally {
            this.listen_1 = true;
          }
        }
      }
      get_value_j01efc_k$() {
        return super.get_value_j01efc_k$();
      }
    }
    protoOf($).lens_drj4fu_k$ = lens;
    protoOf($).lens_u4wb4z_k$ = lens_0;
    protoOf($).valueSet_aujvv6_k$ = valueSet;
    protoOf($).set_revjhg_k$ = set;
    initMetadataForClass($, 'ValidationValueLens', VOID, VOID, [MutableValidatedValue()], [1]);
    ValidationValueLensClass = $;
  }
  return ValidationValueLensClass;
}
var MutableValidationLensClass;
function MutableValidationLens() {
  if (MutableValidationLensClass === VOID) {
    class $ extends ValidatedLens() {
      constructor(source, validate) {
        return new.target.new_com_lightningkite_reactive_lensing_validation_MutableValidationLens_9i3zhn_k$(source, validate);
      }
      static new_com_lightningkite_reactive_lensing_validation_MutableValidationLens_9i3zhn_k$(source, validate) {
        return this.new_com_lightningkite_reactive_lensing_validation_ValidatedLens_ex8sz0_k$(source, validate);
      }
      *set_revjhg_k$(value, $completion) {
        var issue = this.validate_1(value);
        this.baseNode_1.report_ins8zt_k$(issue);
        protoOf(ValidatedLens()).set_state_wnfcx0_k$.call(this, _ReactiveState___init__impl__fvdp9b(value));
        if (issue == null || issue.setValue_1) {
          // Inline function 'com.lightningkite.reactive.lensing.validation.ValidatedLens.withoutListening' call
          try {
            this.listen_1 = false;
            yield* this.source_1.set_revjhg_k$(value, $completion);
          }finally {
            this.listen_1 = true;
          }
        }
        return Unit_instance;
      }
    }
    protoOf($).lens_drj4fu_k$ = lens_1;
    protoOf($).lens_u4wb4z_k$ = lens_2;
    initMetadataForClass($, 'MutableValidationLens', VOID, VOID, [MutableValidated()], [1]);
    MutableValidationLensClass = $;
  }
  return MutableValidationLensClass;
}
function check($this, value) {
  return $this.baseNode_1.report_ins8zt_k$($this.validate_1(value));
}
var ValidatedValueLensClass;
function ValidatedValueLens() {
  if (ValidatedValueLensClass === VOID) {
    class $ extends BaseReactiveValue() {
      static new_com_lightningkite_reactive_lensing_validation_ValidatedValueLens_hzdggt_k$(source, validate) {
        var $this = this.new_com_lightningkite_reactive_core_BaseReactiveValue_bwum4c_k$(source.get_value_j01efc_k$());
        $this.source_1 = source;
        $this.validate_1 = validate;
        $this.baseNode_1 = new (IssueNode())($this.source_1.get_node_wor8sr_k$());
        $this.myListen_1 = null;
        $this.listen_1 = true;
        return $this;
      }
      get_node_wor8sr_k$() {
        // Inline function 'kotlin.also' call
        var this_0 = this.baseNode_1;
        if (this.myListen_1 == null) {
          check(this, this.source_1.get_value_j01efc_k$());
        }
        return this_0;
      }
      set_value_v1vabv_k$(value) {
        super.set_value_v1vabv_k$(value);
      }
      get_value_j01efc_k$() {
        if (this.myListen_1 == null) {
          // Inline function 'kotlin.also' call
          var this_0 = this.source_1.get_value_j01efc_k$();
          check(this, this_0);
          super.set_value_v1vabv_k$(this_0);
        }
        return super.get_value_j01efc_k$();
      }
      activate_yijg9v_k$() {
        super.activate_yijg9v_k$();
        this.baseNode_1.connect_ivqcka_k$();
        var tmp = this;
        tmp.myListen_1 = this.source_1.addListener_6y9mct_k$(() => {
          var tmp;
          if (this.listen_1) {
            // Inline function 'kotlin.also' call
            var this_0 = this.source_1.get_value_j01efc_k$();
            check(this, this_0);
            this.set_value_v1vabv_k$(this_0);
            tmp = Unit_instance;
          }
          return Unit_instance;
        });
        // Inline function 'kotlin.also' call
        var this_0 = this.source_1.get_value_j01efc_k$();
        check(this, this_0);
        this.set_value_v1vabv_k$(this_0);
      }
      deactivate_pmdz1g_k$() {
        super.deactivate_pmdz1g_k$();
        this.baseNode_1.disconnect_t9cc0c_k$();
        var tmp0_safe_receiver = this.myListen_1;
        if (tmp0_safe_receiver == null)
          null;
        else
          tmp0_safe_receiver();
        this.myListen_1 = null;
      }
    }
    initMetadataForClass($, 'ValidatedValueLens', VOID, VOID, [ReactiveValue(), Reactive()]);
    ValidatedValueLensClass = $;
  }
  return ValidatedValueLensClass;
}
function check_0($this, state) {
  // Inline function 'com.lightningkite.reactive.core.ReactiveState.onSuccess' call
  // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
  // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
  var tmp0_subject = _ReactiveState___get_raw__impl__92ipya(state);
  var tmp;
  if (equals(tmp0_subject, InternalReactiveNotReady_instance)) {
    tmp = null;
  } else {
    if (equals(tmp0_subject, InternalReactiveNotActive_instance)) {
      tmp = null;
    } else {
      if (tmp0_subject instanceof InternalReactiveThrownException()) {
        _ReactiveState___get_raw__impl__92ipya(state).exception_1;
        tmp = null;
      } else {
        if (tmp0_subject instanceof InternalReactiveWrapper()) {
          var value = _ReactiveState___get_raw__impl__92ipya(state).other_1;
          $this.baseNode_1.report_ins8zt_k$($this.validate_1(value));
          tmp = Unit_instance;
        } else {
          var value_0 = _ReactiveState___get_raw__impl__92ipya(state);
          $this.baseNode_1.report_ins8zt_k$($this.validate_1(value_0));
          tmp = Unit_instance;
        }
      }
    }
  }
  return tmp;
}
var ValidatedLensClass;
function ValidatedLens() {
  if (ValidatedLensClass === VOID) {
    class $ extends BaseReactive() {
      static new_com_lightningkite_reactive_lensing_validation_ValidatedLens_ex8sz0_k$(source, validate) {
        var $this = this.new_com_lightningkite_reactive_core_BaseReactive_2kvjp3_k$(source.get_state_wc71uu_k$());
        $this.source_1 = source;
        $this.validate_1 = validate;
        $this.baseNode_1 = new (IssueNode())($this.source_1.get_node_wor8sr_k$());
        $this.myListen_1 = null;
        $this.listen_1 = true;
        return $this;
      }
      get_node_wor8sr_k$() {
        // Inline function 'kotlin.also' call
        var this_0 = this.baseNode_1;
        if (this.myListen_1 == null) {
          check_0(this, this.source_1.get_state_wc71uu_k$());
        }
        return this_0;
      }
      set_state_wnfcx0_k$(value) {
        super.set_state_wnfcx0_k$(value);
      }
      get_state_wc71uu_k$() {
        if (this.myListen_1 == null) {
          // Inline function 'kotlin.also' call
          var this_0 = new (ReactiveState())(this.source_1.get_state_wc71uu_k$());
          var p0 = this_0.raw_1;
          check_0(this, p0);
          var tmp$ret$0 = this_0.raw_1;
          super.set_state_wnfcx0_k$(tmp$ret$0);
        }
        return super.get_state_wc71uu_k$();
      }
      activate_yijg9v_k$() {
        super.activate_yijg9v_k$();
        this.baseNode_1.connect_ivqcka_k$();
        var tmp = this;
        tmp.myListen_1 = this.source_1.addListener_6y9mct_k$(() => {
          var tmp;
          if (this.listen_1) {
            // Inline function 'kotlin.also' call
            var this_0 = new (ReactiveState())(this.source_1.get_state_wc71uu_k$());
            var p0 = this_0.raw_1;
            check_0(this, p0);
            var tmp$ret$0 = this_0.raw_1;
            this.set_state_wnfcx0_k$(tmp$ret$0);
            tmp = Unit_instance;
          }
          return Unit_instance;
        });
        // Inline function 'kotlin.also' call
        var this_0 = new (ReactiveState())(this.source_1.get_state_wc71uu_k$());
        var p0 = this_0.raw_1;
        check_0(this, p0);
        var tmp$ret$2 = this_0.raw_1;
        this.set_state_wnfcx0_k$(tmp$ret$2);
      }
      deactivate_pmdz1g_k$() {
        super.deactivate_pmdz1g_k$();
        this.baseNode_1.disconnect_t9cc0c_k$();
        var tmp0_safe_receiver = this.myListen_1;
        if (tmp0_safe_receiver == null)
          null;
        else
          tmp0_safe_receiver();
        this.myListen_1 = null;
      }
    }
    initMetadataForClass($, 'ValidatedLens', VOID, VOID, [Reactive()]);
    ValidatedLensClass = $;
  }
  return ValidatedLensClass;
}
//region block: exports
export {
  audit as audit192z89pit0lev,
  audit_0 as audit21rk6r0re4qdb,
};
//endregion

//# sourceMappingURL=validation.mjs.map
